import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, InjectReactive } from "vue-property-decorator";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
// import manualAddCpn from "../questionBank/manualAdd.vue";
// import selectQuestion from "./questionBank/selectedQuestion.vue";
import { randomNumber } from "@/utils/commonUtil";
let QuestionnaireComponent = class QuestionnaireComponent extends Vue {
  constructor() {
    super(...arguments);
    this.isUnique = false;
    this.activeTab = 1;
  }
  getIcon(name) {
    const nameTrans = {
      "1": "el-icon-help",
      "2": "el-icon-circle-check",
      "3": "el-icon-edit-outline",
      "4": "el-icon-s-unfold",
      "6": "el-icon-folder-opened",
      "21": "el-icon-d-caret",
      "22": "el-icon-finished",
      "7": "el-icon-mobile",
      "11": "el-icon-document",
      "12": "el-icon-document-remove",
      "23": "el-icon-s-grid",
      "13": "el-icon-date",
      "14": "el-icon-office-building",
      "9": "el-icon-s-help",
      "10": "el-icon-success",
      "25": "el-icon-user",
      "26": "el-icon-user",
      "27": "el-icon-user",
      "28": "el-icon-watch",
      "29": "el-icon-service",
      "30": "el-icon-notebook-2",
      "31": "el-icon-guide",
      "5": "el-icon-picture-outline",
      "8": "el-icon-tickets",
      "15": "el-icon-minus",
      "16": "el-icon-files",
      "24": "el-icon-c-scale-to-original"
    };
    return nameTrans[name] || "el-icon-setting";
  }
  isUniqueChange(val) {
    QuestionnaireEditModule.SET_BASIC_DATA_UNIQUE(val);
    const addArr = this.cmpsData.filter(item => item.key === "uniqueArray")[0].questionItem;
    if (val) {
      addArr.forEach((item, index) => {
        this.basicsClick(item, index);
      });
    } else {
      this.$parent.$refs.modulesPreview.handleDelete("unique");
      //  QuestionnaireEditModule.SET_DELETE_COMPONENTS(index);
    }
  }
  handleClick(tab) {
    this.activeTab = tab;
  }
  get participateUniqueCheck() {
    return QuestionnaireEditModule.basicData.participateUniqueCheck;
  }
  get isModel() {
    return QuestionnaireEditModule.isModel;
  }
  get activeIndex() {
    return QuestionnaireEditModule.activeIndex;
  }
  get isConfigforAllShow() {
    return QuestionnaireEditModule.isConfigforAllShow;
  }
  // $ 添加组件
  basicsClick(item, index) {
    if (this.activitySource === "LIVE_PUBLIC_WELFARE_ACTIVITY" || this.createSource === "LIVE_PUBLIC_WELFARE") {
      // 直播活动 仅支持添加一个预约组件
      const status = QuestionnaireEditModule.dataList.some(item => item.componentName === 30);
      if (status) {
        this.$message.warning("您已添加过预约组件");
        return;
      }
    }
    let nItem = JSON.parse(JSON.stringify(item));
    //生成假id
    nItem.data.id = Number("1" + (randomNumber(6) + "")) * -1;
    if (nItem.data.optionsList && nItem.data.optionsList.length > 0) {
      nItem.data.optionsList.forEach(item => {
        return item.id = Number("1" + (randomNumber(6) + "")) * -1;
      });
    }
    const obj = {
      item: nItem,
      index
    };
    QuestionnaireEditModule.SET_ADD_COMPONENTS(obj);
    QuestionnaireEditModule.SET_INDEX_COMPONENTS(this.activeIndex + 1);
  }
};
__decorate([Prop({
  type: Array
})], QuestionnaireComponent.prototype, "cmpsData", void 0);
__decorate([Prop({
  type: Array
})], QuestionnaireComponent.prototype, "pretendData", void 0);
__decorate([Prop({
  default: "ACTIVITY_INTERACT"
})], QuestionnaireComponent.prototype, "activityQuestionnaireProperty", void 0);
__decorate([InjectReactive()], QuestionnaireComponent.prototype, "activitySource", void 0);
__decorate([InjectReactive()], QuestionnaireComponent.prototype, "createSource", void 0);
__decorate([InjectReactive()], QuestionnaireComponent.prototype, "surveyType", void 0);
QuestionnaireComponent = __decorate([Component({
  name: "questionnaireComponent",
  components: {},
  filters: {}
})], QuestionnaireComponent);
export default QuestionnaireComponent;